<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="layout">
    <div class="layout__container container-xl">
        <div
            class="layout__container__top d-flex flex-column text-center text-md-start"
        >
            <h1 class="layout__container__top__title mt-4 pt-2 pb-md-0 pb-2">
                {{ 'fe_precheckin_layout_container_top_title' | translate }}
            </h1>
            <span class="layout__container__top__subtitle mb-4 pb-md-0 pb-2">{{
                'fe_precheckin_layout_container_top_subtitle' | translate
            }}</span>
        </div>
        <div class="layout__container__middle mt-md-4 mt-0 pt-md-2 pt-0">
            <span
                class="layout__container__middle__text justify-content-end d-none d-md-flex"
                *ngIf="indicates"
                >{{
                    'fe_precheckin_layout_container_middle_text' | translate
                }}</span
            >
            <div class="layout__container__middle__row row">
                <div
                    class="layout__container__middle__row__first col-md-4 col-12 pb-md-0 pb-2"
                >
                    <ng-content select="[precheckinProgress]"></ng-content>
                </div>
                <div
                    class="layout__container__middle__row__second col-md-8 col-12"
                >
                    <ng-content select="[precheckinStep]"></ng-content>
                </div>
            </div>
        </div>
        <ng-content select="[btns]"></ng-content>
    </div>
</section>
